import { gql, useQuery } from '@apollo/client';

export const GET_ALL_PLATFORM_COMPANIES = gql`
  query getAllPlatformCompanies {
    getAllPlatformCompanies {
      _id
      name
      businessAddress
      email
      logoFileId
      phoneNumber
      timezone
      timezoneFullFormat
      street
      city
      country
      zipCode
      logoUrl
      ownerMemberId
      subscriptionId
      datevNumberId
      datevNumber {
        _id
        datevNumber
      }
      parentCompanyId
      parentCompany {
        name
      }
      departments {
        _id
        name
      }
    }
  }
`;

export const useGetAllPlatformCompanies = () => {
  const { data, loading } = useQuery(GET_ALL_PLATFORM_COMPANIES, {
    fetchPolicy: 'network-only',
  });

  const companies = data?.getAllPlatformCompanies || [];

  return {
    loading,
    companies,
  };
};
